import type { ReactNode } from "react";

export function StatusChip({
  children,
  tone: _tone = "neutral",
}: {
  children: ReactNode;
  tone?: "accent" | "danger" | "draft" | "issued" | "neutral" | "overdue" | "paid" | "positive" | "sent" | "warning";
}) {
  return <span className="status-chip">{children}</span>;
}
